
        if (globalThis.__TAURI__) {
            const [{ getCurrentWindow }, { getCurrentWebview }, { load }] = await Promise.all([
                import('@tauri-apps/api/window'),
                import('@tauri-apps/api/webview'),
                import('@tauri-apps/plugin-store'),
            ]);

            const appWindow = getCurrentWindow();

            document.getElementById('titlebar-minimize')?.addEventListener('click', () => appWindow.minimize());
            document.getElementById('titlebar-maximize')?.addEventListener('click', () => appWindow.toggleMaximize());
            document.getElementById('titlebar-close')?.addEventListener('click', () => appWindow.hide());

            try {
                const webview = await getCurrentWebview();
                const store = await load('users.json', { autoSave: false, defaults: {} });
                const zoomStore = await store.get('zoom');

                if (typeof zoomStore === 'number' && zoomStore > 0) {
                    await webview.setZoom(zoomStore);
                }

                let currentZoom = zoomStore ?? 1;
                const setZoom = async (zoom) => {
                    currentZoom = zoom;
                    await webview.setZoom(zoom);
                    await store.set('zoom', zoom);
                    await store.save();
                };

                globalThis.addEventListener('keydown', async (e) => {
                    if (!e.ctrlKey) return;

                    switch (e.key) {
                        case '+':
                        case '=':
                            await setZoom(currentZoom * 1.1);
                            e.preventDefault();
                            break;
                        case '-':
                            await setZoom(currentZoom / 1.1);
                            e.preventDefault();
                            break;
                        case '0':
                            await setZoom(1);
                            e.preventDefault();
                            break;
                    }
                });
            } catch (err) {
                console.warn('Zoom setup skipped:', err);
            }
        }
    